import {
  buildCollection,
  buildProperty,
} from "@firecms/core";

export type DeletedUser = {
  uid: string;
  email?: string;
  authCreatedAt?: unknown;
  deletedAt?: unknown;
  publicProfileSnapshot?: Record<string, unknown>;
  privateDataSnapshot?: Record<string, unknown>;
};

export const deletedUsersCollection = buildCollection<DeletedUser>({
  name: "Deleted users",
  singularName: "Deleted user",
  description:
    "Archived account snapshots written when a user deletes their account.",
  id: "deletedUsers",
  path: "deletedUsers",
  icon: "Archive",
  group: "Admin",
  permissions: () => ({
    read: true,
    edit: false,
    create: false,
    delete: false,
  }),
  properties: {
    uid: buildProperty({
      name: "User ID",
      dataType: "string",
      readOnly: true,
    }),
    email: buildProperty({
      name: "Email",
      dataType: "string",
      readOnly: true,
    }),
    authCreatedAt: buildProperty({
      name: "Auth created at",
      dataType: "timestamp",
      readOnly: true,
    }),
    deletedAt: buildProperty({
      name: "Deleted at",
      dataType: "timestamp",
      readOnly: true,
    }),
    publicProfileSnapshot: buildProperty({
      name: "Public profile snapshot",
      dataType: "map",
      readOnly: true,
    }),
    privateDataSnapshot: buildProperty({
      name: "Private data snapshot",
      dataType: "map",
      readOnly: true,
    }),
  },
});
